import { render, staticRenderFns } from "./DeviceFleetCard.vue?vue&type=template&id=b213b86e&scoped=true"
import script from "./DeviceFleetCard.vue?vue&type=script&lang=js"
export * from "./DeviceFleetCard.vue?vue&type=script&lang=js"
import style0 from "./DeviceFleetCard.vue?vue&type=style&index=0&id=b213b86e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b213b86e",
  null
  
)

export default component.exports